import { render, staticRenderFns } from "./ObligationEdit.vue?vue&type=template&id=874c6ec2"
import script from "./ObligationEdit.vue?vue&type=script&lang=js"
export * from "./ObligationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports